module.exports = __webpack_public_path__ + "img/nemendahald.d4bd8618.svg";